var DatePickerController = /** @class */ (function () {
    function DatePickerController($mdDialog, date, options) {
        this.$mdDialog = $mdDialog;
        this.date = date;
        this.options = options;
    }
    DatePickerController.prototype.onChange = function (key, value) {
        if (key === "selected-day") {
            var date = value.format("YYYY-MM-DD");
            this.$mdDialog.hide(date);
        }
    };
    DatePickerController.prototype.onTodayButtonClicked = function () {
        var date = moment().format("YYYY-MM-DD");
        this.$mdDialog.hide(date);
    };
    DatePickerController.prototype.onClearButtonClicked = function () {
        this.date = "";
        this.$mdDialog.hide(this.date);
    };
    DatePickerController.prototype.onCancel = function () {
        this.$mdDialog.cancel();
    };
    DatePickerController.$inject = ['$mdDialog', 'date', 'options'];
    return DatePickerController;
}());
